import { render } from "./LineFold.vue?vue&type=template&id=37f35b5e"
import script from "./LineFold.vue?vue&type=script&lang=js"
export * from "./LineFold.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__